import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = { class: "py-2" }
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "py-2" }
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "py-2" }
const _hoisted_11 = { class: "py-2" }
const _hoisted_12 = { class: "py-2" }
const _hoisted_13 = ["value", "onClick"]
const _hoisted_14 = { class: "py-2" }
const _hoisted_15 = ["value", "onClick"]
const _hoisted_16 = { class: "py-2" }
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = { class: "py-2" }
const _hoisted_19 = { class: "py-2" }
const _hoisted_20 = { class: "py-2" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "py-2" }
const _hoisted_23 = { class: "py-2 flex items-center gap-3" }
const _hoisted_24 = { class: "my-4 flex justify-center gap-8" }

import { useStore } from 'vuex'
import { ref, watch, computed } from 'vue'
import DialogComponent from '@/components/doalog/DialogComponent.vue'
import {
  CouponConditionDepositTypeEnum,
  CouponConditionTurnOverEnum,
  CouponConditionType,
  CouponConditionBonusTypeEnum,
  CouponConditionModeEnum,
  CouponScheduleRepeatUnitEnum,
  CouponScheduleDayOfWeekEnum,
} from '@/views/coupon/type/coupon-condition.type'
import DropdownComponent from '@/components/tools/DropdownComponent.vue'
import { Switch } from '@headlessui/vue'
import { useI18n } from 'vue-i18n'
import CouponScheduleSection from './CouponScheduleSection.vue'
import type { ScheduleFormData } from './CouponScheduleSection.vue'
import 'v-calendar/dist/style.css'

interface CouponConditionUpdate {
  operatorId: string
  name: string
  type: CouponConditionBonusTypeEnum
  depositType: CouponConditionDepositTypeEnum
  depositMinimum: number
  depositPeriodStart?: string
  depositPeriodEnd?: string
  turnover: CouponConditionTurnOverEnum
  amount: number
  maxAmount: number
  isActive: boolean
  id: number
  descriptions: string
  turnoverAmount: number
  limitUsePerUser: number
  limitUsePerUserPerDay: number
  codeMode: CouponConditionModeEnum
  limitUsePerCampaign: number
  newUserDuration: number
  hasSchedule: boolean
  scheduleStartDate?: string
  scheduleEndDate?: string
  scheduleAllDay?: boolean
  scheduleStartTime?: string
  scheduleEndTime?: string
  scheduleRepeatAmount?: number
  scheduleRepeatUnit?: CouponScheduleRepeatUnitEnum
  scheduleDaysOfWeek?: CouponScheduleDayOfWeekEnum[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateCouponConditionDialog',
  props: { show: Boolean, couponConditionUpdate: Object as () => CouponConditionType },
  emits: [
  'onUpdateTicket',
  'update:show',
  'update:nameValue',
  'update:amountValue',
  'update:maxAmountValue',
  'update:descriptionsValue',
  'update:turnoverAmountValue',
  'update:depositMinimum',
  'update:limitUsePerUser',
  'update:limitUsePerUserPerDay',
  'update:limitUsePerCampaign',
  'update:newUserDuration',
],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18n()

const bonusTypeOption = computed(() => [
  { label: t('messages.coupon.fix_amount'), value: CouponConditionBonusTypeEnum.FIXED_AMOUNT },
  { label: t('messages.coupon.deposit_percent'), value: CouponConditionBonusTypeEnum.DEPOSIT_PERCENTAGE },
  { label: t('messages.coupon.valid_balance_percent'), value: CouponConditionBonusTypeEnum.VALIDA_BALANCE_PERCENT },
])

const depositTypeOption = ref(
  computed(() => [
    { label: t('messages.coupon.none'), value: CouponConditionDepositTypeEnum.NONE },
    { label: t('messages.coupon.single_time_latest'), value: CouponConditionDepositTypeEnum.SINGLE_TIME_LATEST },
    { label: t('messages.coupon.multiple_time_latest'), value: CouponConditionDepositTypeEnum.MULTIPLE_TIME_LATEST },
    { label: t('messages.coupon.cumulative'), value: CouponConditionDepositTypeEnum.CUMULATIVE },
    { label: t('messages.coupon.period'), value: CouponConditionDepositTypeEnum.PERIOD },
  ])
)

const turnoverOption = computed(() => [
  { label: t('messages.coupon.fix_amount'), value: CouponConditionTurnOverEnum.FIXED_AMOUNT },
  { label: t('messages.coupon.bonus_percent'), value: CouponConditionTurnOverEnum.BONUS_PERCENT },
  { label: t('messages.coupon.none'), value: CouponConditionTurnOverEnum.NONE },
])

const modeOption = computed(() => [
  { label: t('messages.coupon.generic'), value: CouponConditionModeEnum.GENERIC },
  { label: t('messages.coupon.unique'), value: CouponConditionModeEnum.UNIQUE },
])



const store = useStore()

const disableSource = ref(false)
const disableLimitUsePerCampaign = ref(false)
const hasSchedule = ref(false)
const depositPeriodStart = ref<Date | null>(null)
const depositPeriodEnd = ref<Date | null>(null)

const scheduleForm = ref<ScheduleFormData>({
  scheduleStartDate: null,
  scheduleEndDate: null,
  scheduleAllDay: true,
  scheduleStartTime: null,
  scheduleEndTime: null,
  scheduleRepeatAmount: 1,
  scheduleRepeatUnit: CouponScheduleRepeatUnitEnum.NONE,
  scheduleDaysOfWeek: [],
})

const selectedBonusType = ref<{ label: string; value: CouponConditionBonusTypeEnum }>({
  label: t('messages.coupon.fix_amount'),
  value: CouponConditionBonusTypeEnum.FIXED_AMOUNT,
})

const selectedMode = ref<{ label: string; value: CouponConditionModeEnum }>({
  label: t('messages.coupon.generic'),
  value: CouponConditionModeEnum.GENERIC,
})

const selectedDepositType = ref<{ label: string; value: CouponConditionDepositTypeEnum }>({
  label: t('messages.coupon.none'),
  value: CouponConditionDepositTypeEnum.NONE,
})

const selectedTurnover = ref<{ label: string; value: CouponConditionTurnOverEnum }>({
  label: t('messages.coupon.bonus_percent'),
  value: CouponConditionTurnOverEnum.BONUS_PERCENT,
})

const selectedIsActive = ref<boolean>(true)

const name = computed({
  get() { return props.couponConditionUpdate?.name },
  set(newValue) { emit('update:nameValue', newValue) },
})

const descriptions = computed({
  get() { return props.couponConditionUpdate?.descriptions },
  set(newValue) { emit('update:descriptionsValue', newValue) },
})

const maxAmount = computed({
  get() { return props.couponConditionUpdate?.maxAmount },
  set(newValue) { emit('update:maxAmountValue', newValue) },
})

const amount = computed({
  get() { return props.couponConditionUpdate?.amount },
  set(newValue) { emit('update:amountValue', newValue) },
})

const turnoverAmount = computed({
  get() { return props.couponConditionUpdate?.turnoverAmount },
  set(newValue) { emit('update:turnoverAmountValue', newValue) },
})

const depositMinimum = computed({
  get() { return props.couponConditionUpdate?.depositMinimum },
  set(newValue) { emit('update:depositMinimum', newValue) },
})

const limitUsePerUser = computed({
  get() { return props.couponConditionUpdate?.limitUsePerUser },
  set(newValue) { emit('update:limitUsePerUser', newValue) },
})

const limitUsePerUserPerDay = computed({
  get() { return props.couponConditionUpdate?.limitUsePerUserPerDay },
  set(newValue) { emit('update:limitUsePerUserPerDay', newValue) },
})

const limitUsePerCampaign = computed({
  get() { return props.couponConditionUpdate?.limitUsePerCampaign },
  set(newValue) { emit('update:limitUsePerCampaign', newValue) },
})

const newUserDuration = computed({
  get() { return props.couponConditionUpdate?.newUserDuration },
  set(newValue) { emit('update:newUserDuration', newValue) },
})

const onSelectMode = (option: { label: string; value: CouponConditionModeEnum }) => {
  selectedMode.value = option
}

const onSelectBonusType = (option: { label: string; value: CouponConditionBonusTypeEnum }) => {
  if (option.value === CouponConditionBonusTypeEnum.DEPOSIT_PERCENTAGE) {
    if (selectedDepositType.value.value === CouponConditionDepositTypeEnum.NONE) {
      selectedDepositType.value = {
        label: t('messages.coupon.single_time_latest'),
        value: CouponConditionDepositTypeEnum.SINGLE_TIME_LATEST,
      }
    }
    depositTypeOption.value = [
      { label: t('messages.coupon.single_time_latest'), value: CouponConditionDepositTypeEnum.SINGLE_TIME_LATEST },
      { label: t('messages.coupon.multiple_time_latest'), value: CouponConditionDepositTypeEnum.MULTIPLE_TIME_LATEST },
      { label: t('messages.coupon.cumulative'), value: CouponConditionDepositTypeEnum.CUMULATIVE },
      { label: t('messages.coupon.period'), value: CouponConditionDepositTypeEnum.PERIOD },
    ]
  } else {
    depositTypeOption.value = [
      { label: t('messages.coupon.none'), value: CouponConditionDepositTypeEnum.NONE },
      { label: t('messages.coupon.single_time_latest'), value: CouponConditionDepositTypeEnum.SINGLE_TIME_LATEST },
      { label: t('messages.coupon.multiple_time_latest'), value: CouponConditionDepositTypeEnum.MULTIPLE_TIME_LATEST },
      { label: t('messages.coupon.cumulative'), value: CouponConditionDepositTypeEnum.CUMULATIVE },
      { label: t('messages.coupon.period'), value: CouponConditionDepositTypeEnum.PERIOD },
    ]
  }
  selectedBonusType.value = option
}

const onSelectDepositType = (option: { label: string; value: CouponConditionDepositTypeEnum }) => {
  if (option.value !== CouponConditionDepositTypeEnum.PERIOD) {
    depositPeriodStart.value = null
    depositPeriodEnd.value = null
  }
  selectedDepositType.value = option
}

const onSelectTurnOver = (option: { label: string; value: CouponConditionTurnOverEnum }) => {
  selectedTurnover.value = option
}

const onToggleIsActive = () => {
  selectedIsActive.value = !selectedIsActive.value
}

const onUpdateCouponCondition = () => {
  if (!props.couponConditionUpdate?.id) return
  const isPeriod = selectedDepositType.value.value === CouponConditionDepositTypeEnum.PERIOD
  const payload: CouponConditionUpdate = {
    id: props.couponConditionUpdate.id,
    operatorId: store?.state?.selectedOperator?.operatorId,
    name: name.value as string,
    type: selectedBonusType.value.value,
    depositType: selectedDepositType.value.value,
    depositMinimum: Number(depositMinimum.value),
    ...(isPeriod && depositPeriodStart.value && { depositPeriodStart: depositPeriodStart.value.toISOString() }),
    ...(isPeriod && depositPeriodEnd.value && { depositPeriodEnd: depositPeriodEnd.value.toISOString() }),
    turnover: selectedTurnover.value.value,
    amount: Number(amount.value),
    maxAmount: Number(maxAmount.value),
    isActive: selectedIsActive.value,
    descriptions: descriptions.value as string,
    turnoverAmount: Number(turnoverAmount.value),
    limitUsePerUser: Number(limitUsePerUser.value),
    limitUsePerUserPerDay: Number(limitUsePerUserPerDay.value),
    limitUsePerCampaign: Number(limitUsePerCampaign.value),
    codeMode: selectedMode.value.value,
    newUserDuration: Number(newUserDuration.value),
    hasSchedule: hasSchedule.value,
    ...(hasSchedule.value && {
      scheduleStartDate: scheduleForm.value.scheduleStartDate ?? undefined,
      scheduleEndDate: scheduleForm.value.scheduleEndDate ?? undefined,
      scheduleAllDay: scheduleForm.value.scheduleAllDay,
      scheduleStartTime: scheduleForm.value.scheduleStartTime ?? undefined,
      scheduleEndTime: scheduleForm.value.scheduleEndTime ?? undefined,
      scheduleRepeatAmount: scheduleForm.value.scheduleRepeatAmount ?? undefined,
      scheduleRepeatUnit: scheduleForm.value.scheduleRepeatUnit,
      scheduleDaysOfWeek: scheduleForm.value.scheduleDaysOfWeek,
    }),
  }
  emit('onUpdateTicket', payload)
}

function onChangeDepositPeriodStart(event: Event) {
  const target = event.target as HTMLInputElement
  const value = target.value
  if (!value || isNaN(Date.parse(value))) {
    depositPeriodStart.value = null
    return
  }
  const parsedDate = new Date(value)
  if (!isNaN(parsedDate.getTime())) {
    depositPeriodStart.value = parsedDate
  }
}

function onChangeDepositPeriodEnd(event: Event) {
  const target = event.target as HTMLInputElement
  const value = target.value
  if (!value || isNaN(Date.parse(value))) {
    depositPeriodEnd.value = null
    return
  }
  const parsedDate = new Date(value)
  if (!isNaN(parsedDate.getTime())) {
    depositPeriodEnd.value = parsedDate
  }
}

watch(
  () => props.couponConditionUpdate?.isActive,
  () => {
    if (props.couponConditionUpdate?.isActive !== undefined) {
      selectedIsActive.value = props.couponConditionUpdate.isActive
    }
  }
)

watch(
  () => props.couponConditionUpdate?.type,
  () => {
    if (props.couponConditionUpdate?.type !== undefined) {
      const typeOption = bonusTypeOption.value.find(o => o.value === props.couponConditionUpdate?.type)
      if (typeOption) {
        selectedBonusType.value = typeOption
        if (props.couponConditionUpdate.type === CouponConditionBonusTypeEnum.DEPOSIT_PERCENTAGE) {
          if (selectedDepositType.value.value === CouponConditionDepositTypeEnum.NONE) {
            selectedDepositType.value = {
              label: t('messages.coupon.single_time_latest'),
              value: CouponConditionDepositTypeEnum.SINGLE_TIME_LATEST,
            }
          }
        }
      }
    }
  }
)

watch(
  () => props.couponConditionUpdate?.depositType,
  () => {
    if (props.couponConditionUpdate?.depositType !== undefined) {
      const depositOption = depositTypeOption.value.find(o => o.value === props.couponConditionUpdate?.depositType)
      if (depositOption) {
        selectedDepositType.value = depositOption
      }
    }
  }
)

// Pre-populate period deposit dates from existing record
watch(
  () => props.couponConditionUpdate?.depositPeriodStart,
  (val) => {
    depositPeriodStart.value = val ? new Date(val) : null
  }
)

watch(
  () => props.couponConditionUpdate?.depositPeriodEnd,
  (val) => {
    depositPeriodEnd.value = val ? new Date(val) : null
  }
)

watch(
  () => props.couponConditionUpdate?.codeMode,
  () => {
    if (props.couponConditionUpdate?.codeMode !== undefined) {
      const couponModeOption = modeOption.value.find(o => o.value === props.couponConditionUpdate?.codeMode)
      disableLimitUsePerCampaign.value = props.couponConditionUpdate.codeMode === CouponConditionModeEnum.UNIQUE
      if (couponModeOption) selectedMode.value = couponModeOption
    }
  }
)

watch(
  () => props.couponConditionUpdate?.turnover,
  () => {
    if (props.couponConditionUpdate?.turnover !== undefined) {
      const turnoverOptionItem = turnoverOption.value.find(o => o.value === props.couponConditionUpdate?.turnover)
      if (turnoverOptionItem) selectedTurnover.value = turnoverOptionItem
    }
  }
)

// Pre-populate schedule from existing record
watch(
  () => props.couponConditionUpdate?.hasSchedule,
  (val) => {
    if (val !== undefined) {
      hasSchedule.value = val
    }
  }
)

watch(
  () => props.couponConditionUpdate,
  (record) => {
    if (record?.hasSchedule) {
      scheduleForm.value = {
        scheduleStartDate: record.scheduleStartDate ?? null,
        scheduleEndDate: record.scheduleEndDate ?? null,
        scheduleAllDay: record.scheduleAllDay ?? true,
        scheduleStartTime: record.scheduleStartTime ?? null,
        scheduleEndTime: record.scheduleEndTime ?? null,
        scheduleRepeatAmount: record.scheduleRepeatAmount ?? 1,
        scheduleRepeatUnit: record.scheduleRepeatUnit ?? CouponScheduleRepeatUnitEnum.NONE,
        scheduleDaysOfWeek: record.scheduleDaysOfWeek ?? [],
      }
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createBlock(DialogComponent, {
    title: _ctx.$t('messages.coupon.update'),
    isOpen: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.name')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
            name: "name",
            type: "text",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, _unref(name)]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.description')) + " ", 1),
          _withDirectives(_createElementVNode("textarea", {
            class: "w-full h-20 rounded-md",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(descriptions) ? (descriptions).value = $event : null)),
            name: "descriptions"
          }, null, 512), [
            [_vModelText, _unref(descriptions)]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.isActive')) + " ", 1),
          _createVNode(_unref(Switch), {
            modelValue: selectedIsActive.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedIsActive).value = $event)),
            class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", selectedIsActive.value ? 'bg-blue-400' : 'bg-red-500']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onToggleIsActive()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass([selectedIsActive.value ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.couponMode')) + " ", 1),
          _createVNode(DropdownComponent, {
            class: "w-full",
            options: _unref(modeOption),
            modelValue: selectedMode.value,
            onOnOptionSelected: onSelectMode,
            isDisable: true
          }, null, 8, ["options", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.bonusType')) + " ", 1),
          _createVNode(DropdownComponent, {
            class: "w-full",
            options: _unref(bonusTypeOption),
            modelValue: selectedBonusType.value,
            onOnOptionSelected: onSelectBonusType
          }, null, 8, ["options", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.bonusAmount')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "amount",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(amount) ? (amount).value = $event : null)),
            type: "number",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, _unref(amount)]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.bonusCap')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "maxAmount",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(maxAmount) ? (maxAmount).value = $event : null)),
            type: "number",
            class: _normalizeClass(['w-full rounded-md', disableSource.value ? 'bg-gray-100 text-gray-400' : '']),
            disabled: disableSource.value
          }, null, 10, _hoisted_9), [
            [_vModelText, _unref(maxAmount)]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.depositType')) + " ", 1),
          _createVNode(DropdownComponent, {
            class: "w-full",
            options: depositTypeOption.value,
            modelValue: selectedDepositType.value,
            onOnOptionSelected: onSelectDepositType,
            isDisable: true
          }, null, 8, ["options", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.depositMinimum')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "depositMinimum",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(depositMinimum) ? (depositMinimum).value = $event : null)),
            type: "number",
            class: "w-full rounded-md text-gray-400 bg-gray-100",
            disabled: true
          }, null, 512), [
            [_vModelText, _unref(depositMinimum)]
          ])
        ]),
        (selectedDepositType.value.value === _unref(CouponConditionDepositTypeEnum).PERIOD)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.depositPeriodStart')) + " ", 1),
                _createVNode(_component_v_date_picker, {
                  modelValue: depositPeriodStart.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((depositPeriodStart).value = $event)),
                  mode: "dateTime",
                  timezone: "Asia/Bangkok",
                  masks: { input: 'DD/MM/YYYY HH:mm' },
                  is24hr: "",
                  locale: "th"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("input", {
                      type: "text",
                      value: inputValue,
                      onClick: togglePopover,
                      onChange: onChangeDepositPeriodStart,
                      class: "w-full rounded-md",
                      placeholder: "DD/MM/YYYY HH:mm"
                    }, null, 40, _hoisted_13)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.depositPeriodEnd')) + " ", 1),
                _createVNode(_component_v_date_picker, {
                  modelValue: depositPeriodEnd.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((depositPeriodEnd).value = $event)),
                  mode: "dateTime",
                  timezone: "Asia/Bangkok",
                  masks: { input: 'DD/MM/YYYY HH:mm' },
                  is24hr: "",
                  locale: "th"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("input", {
                      type: "text",
                      value: inputValue,
                      onClick: togglePopover,
                      onChange: onChangeDepositPeriodEnd,
                      class: "w-full rounded-md",
                      placeholder: "DD/MM/YYYY HH:mm"
                    }, null, 40, _hoisted_15)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.turnoverSetting')) + " ", 1),
          _createVNode(DropdownComponent, {
            class: "w-full",
            options: _unref(turnoverOption),
            modelValue: selectedTurnover.value,
            onOnOptionSelected: onSelectTurnOver
          }, null, 8, ["options", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.turnoverValue')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "turnoverAmount",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(turnoverAmount) ? (turnoverAmount).value = $event : null)),
            type: "number",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, _unref(turnoverAmount)]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.limitUsePerUser')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "limitUsePerUser",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(limitUsePerUser) ? (limitUsePerUser).value = $event : null)),
            type: "number",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, _unref(limitUsePerUser)]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.limitUsePerUserPerDay')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "limitUsePerUserPerDay",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(limitUsePerUserPerDay) ? (limitUsePerUserPerDay).value = $event : null)),
            type: "number",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, _unref(limitUsePerUserPerDay)]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.limitUsePerCampaign')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "limitUsePerCampaign",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(limitUsePerCampaign) ? (limitUsePerCampaign).value = $event : null)),
            type: "number",
            class: _normalizeClass(['w-full rounded-md', disableLimitUsePerCampaign.value ? 'bg-gray-100 text-gray-400' : '']),
            disabled: disableLimitUsePerCampaign.value
          }, null, 10, _hoisted_21), [
            [_vModelText, _unref(limitUsePerCampaign)]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.newUserDuration')) + " ", 1),
          _withDirectives(_createElementVNode("input", {
            name: "newUserDuration",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(newUserDuration) ? (newUserDuration).value = $event : null)),
            type: "number",
            min: "0",
            class: "w-full rounded-md"
          }, null, 512), [
            [_vModelText, _unref(newUserDuration)]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createTextVNode(_toDisplayString(_ctx.$t('messages.coupon.hasSchedule')) + " ", 1),
          _createVNode(_unref(Switch), {
            modelValue: hasSchedule.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((hasSchedule).value = $event)),
            class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", hasSchedule.value ? 'bg-blue-400' : 'bg-red-500'])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass([hasSchedule.value ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue", "class"])
        ]),
        (hasSchedule.value)
          ? (_openBlock(), _createBlock(CouponScheduleSection, {
              key: 1,
              modelValue: scheduleForm.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((scheduleForm).value = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            type: "reset",
            class: "flex-1 bg-red-500 text-white p-1 px-4 rounded",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('update:show', false)))
          }, _toDisplayString(_ctx.$t('messages.coupon.cancel')), 1),
          _createElementVNode("button", {
            class: "flex-1 bg-blue-500 text-white p-1 px-4 rounded",
            onClick: onUpdateCouponCondition
          }, _toDisplayString(_ctx.$t('messages.coupon.updateCouponCondition')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isOpen"]))
}
}

})